module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "width-box w600"
  }, [(_vm.formData) ? _c('el-form', {
    ref: "projectInfoForm",
    staticClass: "pop-form-wrap",
    attrs: {
      "label-width": "100px",
      "model": _vm.formData
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Cover",
      "prop": "NbImg"
    }
  }, [_c('img-upload', {
    attrs: {
      "tip": "Image recommended size：1920*225"
    },
    model: {
      value: (_vm.formData.NbImg),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbImg", $$v)
      },
      expression: "formData.NbImg"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "NbName"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NbName),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbName", $$v)
      },
      expression: "formData.NbName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Skip Url",
      "prop": "NbUrl"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NbUrl),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbUrl", $$v)
      },
      expression: "formData.NbUrl"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Sort",
      "prop": "NbSort"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.NbSort),
      callback: function($$v) {
        _vm.$set(_vm.formData, "NbSort", _vm._n($$v))
      },
      expression: "formData.NbSort"
    }
  })], 1), _vm._v(" "), (_vm.formData.NbFacode === '0') ? _c('el-form-item', {
    attrs: {
      "label": "Is Leaf",
      "prop": "IsLeaf"
    }
  }, [_c('el-switch', {
    attrs: {
      "on-text": "",
      "off-text": ""
    },
    model: {
      value: (_vm.formData.IsLeaf),
      callback: function($$v) {
        _vm.$set(_vm.formData, "IsLeaf", $$v)
      },
      expression: "formData.IsLeaf"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SeoTitle",
      "prop": "SeoTitle"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small"
    },
    model: {
      value: (_vm.formData.SeoTitle),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SeoTitle", $$v)
      },
      expression: "formData.SeoTitle"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SeoDescribetion",
      "prop": "SeoDescribetion"
    }
  }, [_c('el-input', {
    attrs: {
      "size": "small",
      "autosize": {
        minRows: 4
      },
      "type": "textarea"
    },
    model: {
      value: (_vm.formData.SeoDescribetion),
      callback: function($$v) {
        _vm.$set(_vm.formData, "SeoDescribetion", $$v)
      },
      expression: "formData.SeoDescribetion"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "SeoKey",
      "prop": "SeoKey"
    }
  }, [_vm._l((_vm.dynamicTags), function(tag) {
    return _c('el-tag', {
      key: tag,
      attrs: {
        "closable": "",
        "disable-transitions": false
      },
      on: {
        "close": function($event) {
          return _vm.handleClose(tag)
        }
      }
    }, [_vm._v("\n        " + _vm._s(tag) + "\n      ")])
  }), _vm._v(" "), (_vm.inputVisible) ? _c('el-input', {
    ref: "saveTagInput",
    staticClass: "input-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "blur": _vm.handleInputConfirm
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleInputConfirm($event)
      }
    },
    model: {
      value: (_vm.inputValue),
      callback: function($$v) {
        _vm.inputValue = $$v
      },
      expression: "inputValue"
    }
  }) : _c('el-button', {
    staticClass: "button-new-tag",
    attrs: {
      "size": "small"
    },
    on: {
      "click": _vm.showInput
    }
  }, [_vm._v("+ Add")])], 2), _vm._v(" "), _c('el-form-item', [_c('div', {
    staticClass: "pop-center-btn-wrap"
  }, [(!_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doAdd('projectInfoForm')
      }
    }
  }, [_vm._v("add")]) : _vm._e(), _vm._v(" "), (_vm.formData.Id) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.doUpdate('projectInfoForm')
      }
    }
  }, [_vm._v("save")]) : _vm._e()], 1)])], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-942d2fac","hasScoped":false}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/cms/NavigateionForm.vue
// module id = 786
// module chunks = 1